module.exports = window.COTACAO = window.COTACAO || {};


// WEBPACK FOOTER //
// ./resources/scripts/scope.js